import ExamProxy from './ExamProxy'; // 检查项代理
import IndiProxy from './IndiProxy'; // 指标项代理
import ExamReflect from './ExamReflect';
import IndiReflect from './IndiReflect';

export default class Adapter {
  static init(data) {
    return new this(data);
  }

  constructor(sourceData) {
    // 检查项原始数据
    this.sourceData = sourceData;
    // 检查项解析代理后数据
    this.data = {};
    // 解析数据
    this.handleProxyExam(sourceData);
  }
  /**
   * 为每个检查项进行代理
   * @param {*} exam
   */
  handleProxyExam = (exam = {}) => {
    const { examContent = {}, examFiles = [], examCode, examConfig = {} } = exam;
    // 为检查项所有的属性创建代理
    this.createExamProxy(exam, examCode);
    // 为指标项创建代理
    this.createIndiProxy(examContent, examCode, examConfig);
    // 为指标项所有属性创建反射射属性
    const examIndi = new IndiReflect(examContent);
    const examConData = JSON.parse(JSON.stringify(examIndi))
    exam.examContent = examConData.data;
    // 为检查项所有属性创建反射射属性
    exam = new ExamReflect(exam);
    this.data = exam;
    // // 返回当前代理的数据
    // return exam;
  }


  /**
   * 为检查项所有属性创建代理对象
   * @param {Object} exam
   * @param {Object} examCode
   */
  createExamProxy(exam, examCode) {
    const { examFiles = [], ...rest } = exam;
    const proxy = rest;
    Object.entries(exam).forEach(([key, value]) => {
      exam[key] = new ExamProxy({
        key,
        value,
        examCode,
        self: exam,
      });
    });
  }

  /**
   * 为指标项所有属性创建代理对象
   * @param {*} indi
   * @param {*} indi_code
   * createIndiProxy(examContent, examCode, examConfig)
   */
  createIndiProxy(examContent, examCode, examConfig) {
    Object.entries(examContent).forEach(([key, value]) => {
      examContent[key] = new IndiProxy({
        key,
        value,
        examCode,
        self: examContent,
      });
    });
  }
}
